<template>
  <div>
    <Banners
      :src="require('@/assets/img/news/banner.jpg')"
      title="新闻资讯"
      text="行业资讯文章"
    ></Banners>
    <b-container v-if="show && !hasPhone" class="wow fadeInDown solution">
      <b-row
        class="solution-data"
        v-for="(item, index) in newData.data"
        :key="index"
      >
        <b-col cols="12" md="8" class="solution-text">
          <div class="solution-text-left">
            <h5>{{ item.title }}</h5>
            <p>
              {{ item.source ? `${item.source} / ` : "未知 / " }}
              {{ getDate(item.createTime) }}
            </p>
          </div>
          <div class="solution-text-right">
            <p>{{ item.digest }}</p>
          </div>
          <div class="solution-detailto">
            <a @click="goDetails(item.id)">
              查看详情
              <b-icon-arrow-right></b-icon-arrow-right>
            </a>
          </div>
        </b-col>
        <b-col cols="12" md="4" class="solution-img solution-pad-left-0">
          <img :src="getImgUrl(item.photoUrl)" @click="goDetails(item.id)" />
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="show && hasPhone" class="wow fadeInDown solution">
      <b-row
        class="solution-data"
        v-for="(item, index) in newData.data"
        :key="index"
      >
        <b-col cols="12" md="4" class="solution-img solution-pad-left-0">
          <img :src="getImgUrl(item.photoUrl)" @click="goDetails(item.id)" />
        </b-col>
        <b-col cols="12" md="8" class="solution-text">
          <div class="solution-text-left">
            <h5>{{ item.title }}</h5>
            <p>
              {{ item.source ? `${item.source} / ` : "未知 / " }}
              {{ getDate(item.createTime) }}
            </p>
          </div>
          <div class="solution-text-right">
            <p>{{ item.digest }}</p>
          </div>
          <div class="solution-detailto">
            <a @click="goDetails(item.id)">
              查看详情
              <b-icon-arrow-right></b-icon-arrow-right>
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-pagination
      v-if="newData.data && newData.data.length > 0"
      class="solution-page"
      style="justify-content: center;"
      v-model="page.current"
      :total-rows="page.rows"
      limit="4"
      :perPage="page.perPage"
      first-number
      last-number
    ></b-pagination>
  </div>
</template>
<script>
import Banners from "@/components/banner/Banners.vue";
import Api from "@/apis";
import WOW from "wowjs";
import publicChange from "@/assets/js/index.js";
export default {
  data() {
    return {
      page: {
        current: 1,
        rows: 1,
        perPage: 6
      },
      newData: [],
      show: false,
      hasPhone: false
    };
  },
  watch: {
    "page.current": {
      deep: true,
      handler: function() {
        this.getNewData();
        window, scrollTo(0, 0);
      }
    }
  },
  mounted() {
    this.getNewData();
    this.wow();
    if (this._isMobile()) {
      this.hasPhone = true;
    } else {
      this.hasPhone = false;
    }
    console.log(this.hasPhone);
  },
  components: {
    Banners
  },
  methods: {
    wow() {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    },
    getDate(time) {
      return publicChange.getDate(time);
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    goDetails(id) {
      this.$router.push({
        path: "/new/details",
        query: {
          id: id
        }
      });
    },
    async getNewData() {
      const query = {
        pageSize: this.page.perPage,
        current: this.page.current
      };
      try {
        const data = await Api.CMS.getCms("channel", query);
        console.log(data);
        if (data.data.length > 0) {
          this.show = true;
        }
        this.page.rows = data.total;
        this.newData = data;
      } catch (e) {
        this.$Message.error(e);
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>
<style lang="scss" scoped></style>
